import { AccountConfig, Website } from '@betterfunnel/types';
import { useCallback, useContext, useEffect, useState } from 'react';
import { DashboardContext } from '../../contexts/DashboardContext';
import { SnackbarContext } from '../../contexts/SnackbarContext';
import {
  WebsiteUpdate,
  WebsiteUpdaterContext,
} from '../../contexts/WebsiteUpdaterContext';
import { SEOForm } from '../settings/SEOForm';
import SettingSectionTitle from '../settings/SettingSectionTitle';

interface Props {
  websiteId: string;
  website?: Website;
  onUpdateWebsiteEvent: (_: WebsiteUpdate) => void;
}

export default function ManageWebsiteSEO({
  websiteId,
  website,
  onUpdateWebsiteEvent,
}: Props) {
  const { show } = useContext(SnackbarContext);
  const { selectedDynamicPage, accountConfig } = useContext(DashboardContext);
  const { createWebsiteUpdate } = useContext(WebsiteUpdaterContext);

  const [seoData, setSEOData] = useState<AccountConfig['seo'] | undefined>(
    website?.development.config?.seo,
  );

  useEffect(() => {
    const config = website?.development.config;

    setSEOData({
      ...accountConfig?.seo,
      ...selectedDynamicPage?.data().config?.seo,
      ...config?.seo,
    });
  }, [accountConfig, selectedDynamicPage, website?.development.config]);

  const updateWebsite = useCallback(
    async (data: AccountConfig, reset = false) => {
      if (!selectedDynamicPage) return;
      try {
        const wu = createWebsiteUpdate(
          selectedDynamicPage.id,
          websiteId,
          '',
          '',
          data,
          reset ? 'resetConfig' : 'editConfig',
          [],
          website?.development
            ? JSON.parse(JSON.stringify(website?.development))
            : undefined,
        );
        if (!wu) return;

        onUpdateWebsiteEvent(wu);
        show('Updated');
      } catch (_) {
        show('Failed to update');
      }
    },
    [
      createWebsiteUpdate,
      onUpdateWebsiteEvent,
      selectedDynamicPage,
      show,
      website?.development,
      websiteId,
    ],
  );

  return (
    <div>
      <SettingSectionTitle
        title="SEO"
        description="Edit SEO for the dynamic page."
      />

      <SEOForm
        seo={seoData || {}}
        onChange={(seo) => {
          updateWebsite({
            seo: {
              ...website?.development.config?.seo,
              ...seo,
            },
          });
        }}
        showReset
        onReset={(type) => {
          if (type === 'account') {
            updateWebsite(accountConfig ?? {}, true);
          } else {
            updateWebsite({}, true);
          }
        }}
      />
    </div>
  );
}
